<template>
    <auth-layout>
        <Head>
            <title>Login</title>
        </Head>

        <div class="auth-form">
            <div class="auth-form--form">
                <h3><translate>Legen Sie ihr neues Passwort fest.</translate></h3>
                <form @submit.prevent="submit">
                    <form-input type="email" id="email" :label="this.$gettext('Email Adresse')" v-model="form.email" :placeholder="this.$gettext('john@doe.com')" :error="form.errors.email" icon="email-mail-checkmark" autocomplete="email" autofocus />
                    <form-password id="password" :label="this.$gettext('Passwort')" v-model="form.password" :error="form.errors.password" />
                    <input type="hidden" name="token" v-model="form.token" />
                    <div class="form-actions">
                        <form-button type="submit" color="secondary" icon="lock-shield-prote" :disabled="form.processing" :class="{'btn--processing': form.processing}"><translate>Passwort setzen</translate></form-button>
                    </div>
                </form>
            </div>
            <div class="auth-form--info">
                <p class="body-2 body-2--disabled">
                    <translate>Legen Sie ihr Passwort für Ihren Partfactory Account fest.</translate>
                </p>
            </div>
        </div>
    </auth-layout>
</template>

<script>
import AuthLayout from '@partfactory/Layouts/AuthLayout';
import {useForm} from '@inertiajs/vue3';
import { Head } from '@inertiajs/vue3';
import FormButton from '@partfactory/Shared/Form/FormButton';
import FormPassword from '@partfactory/Shared/Form/FormPassword';
import FormInput from '@partfactory/Shared/Form/FormInput';

export default {
    name: 'PasswordReset',
    components: {
        FormInput,
        FormPassword,
        FormButton,
        AuthLayout,
        Head,
    },
    props: [
        'token',
    ],
    setup () {
        const form = useForm({
            email: null,
            password: null,
            token: null,
        });

        return { form };
    },
    created() {
        this.form.token = this?.token;
    },
    methods: {
        submit() {
            this.form
                .transform(data => ({
                    ...data,
                    _token: this.$page.props.csrf_token,
                }))
                .post(this.$$route('password.reset.post'), {
                    onSuccess: () => {
                        this.form.reset('password');
                    }
                });
        },
    },
};
</script>
